import React, { useState } from 'react';

import { WidgetButton } from 'components/Dashboards/Reporting/_common/widgetButtons/WidgetButton';
import { UploadRisksModal } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';

export const UploadRisksButton = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <WidgetButton icon={'upload'} onClick={() => setShowModal(true)} tooltipContent={'Upload Risks'} />
            <UploadRisksModal isShowModal={showModal} handleModalClose={() => setShowModal(false)} />
        </>
    );
};
